import "./index.css";
import { useEffect,useState } from "react";
import Button from "../button";

function InsightItem({ item, onDismiss }) {
    const [logo, setLogo] = useState('./images/fallback-logo.png');
  
    // Fetch logo only when `url` changes
    useEffect(() => {
      if (!item.url) {
        setLogo('./images/fallback-logo.png');
        return;
      }
  
      let cancelled = false;
  
      const getLogoUrl = async () => {
        const token = process.env.REACT_APP_LOGO_DEV_TOKEN;
        if (!token) {
          if (!cancelled) setLogo('./images/fallback-logo.png');
          return;
        }
        try {
          const domain = new URL(item.url).hostname;
          const call = `https://img.logo.dev/${domain}?token=${token}`;
          const result = await fetch(call);

          if (!cancelled) {
            if (result.ok) {
              setLogo(call);
            } else {
              setLogo('./images/fallback-logo.png');
            }
          }
        } catch (error) {
          if (!cancelled) {
            setLogo('./images/fallback-logo.png');
          }
        }
      };
  
      getLogoUrl();
  
      return () => {
        cancelled = true;
      };
    }, [item]);
  
  return (
    <div className="insight">
    <div className="insight-info-holder tiny-text">
      <img className="feed-logo" src={logo} />
      <div className="insight-date-row">
        <div className="insight-date">{new Date(item.dateDetected).toDateString()}</div>
        {onDismiss && (
          <button
            type="button"
            className="insight-dismiss"
            onClick={() => onDismiss(item)}
            aria-label="Dismiss insight"
          >
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>
          </button>
        )}
      </div>
    </div>
    <div className="insight-insight tiny-text">{item.insight}</div>
    <div className="insight-url-example tiny-text">{item.url}</div>
    <a href={item.url} target="_blank"><div className="insight-url"><Button smallBool={true} text="Read the article" /></div></a>
    </div>
  );
}

export default InsightItem;